export const AUTH_EXPIRED_EVENT = 'medsim:auth-expired';
const BACKUP_PREFIX = 'medsim-transcript-backups';

export const getAuthToken = () => {
  try {
    return localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
  } catch {
    return null;
  }
};

export const transcriptBackupKey = (userId) => `${BACKUP_PREFIX}:${encodeURIComponent(String(userId))}`;

export const clearStoredSession = () => {
  for (const storage of [localStorage, sessionStorage]) {
    try {
      storage.removeItem('authToken');
      storage.removeItem('authUser');
      // Remove old unscoped backups as well as this browser's account backups.
      for (const key of Object.keys(storage)) {
        if (key === BACKUP_PREFIX || key.startsWith(`${BACKUP_PREFIX}:`)) storage.removeItem(key);
      }
    } catch {
      // The in-memory session is still cleared when browser storage is blocked.
    }
  }
};

export const invalidateSession = (requestToken) => {
  // An old request must never sign out an account that logged in meanwhile.
  const currentToken = getAuthToken();
  if (currentToken && currentToken !== requestToken) return;
  clearStoredSession();
  window.dispatchEvent(new Event(AUTH_EXPIRED_EVENT));
};
